import React, {useState, setGlobal, getGlobal, useEffect} from 'reactn';
import { Radio, Checkbox, Button, Skeleton, Switch, notification, Popover } from 'antd';
import { useFirestore } from 'reactfire';


const Thyroid = (props) => {

    const [isThyroid, setThyroid] = useState('No');
    const [isNeckMass, setNeckMass] = useState();
    const [isNeckNodes, setNeckNodes] = useState();
    const [popup, setPopup] = useState(false);


    
    const firestore = useFirestore();


    const [state, setState] = useState();
    const [loading, setLoading] = useState(false);
    const [loadingBtn, setLoadingBtn] = useState(false);
    
    const getSelectedFields = (event) => {
        setState({
            ...state,
            [event.target.name] : event.target.value
        });
    }

    useEffect(() => {
        getCurrentExmLocation();
    }, [props]);

    const getCurrentExmLocation = () => {
        setLoading(true);
        if (getGlobal().examination_location) {
            console.log(getGlobal().examination_location.Thyroid)
            setState(getGlobal().examination_location.Thyroid && getGlobal().examination_location.Thyroid);
            setThyroid(getGlobal().examination_location.Thyroid && getGlobal().examination_location.Thyroid.isThyroid
                ? getGlobal.examination_location.Thyroid.isThyroid : 'No');
            setNeckMass(getGlobal().examination_location.Thyroid && getGlobal().examination_location.Thyroid.isNeckMass);
            setNeckNodes(getGlobal().examination_location.Thyroid && getGlobal().examination_location.Thyroid.isPalpable)

        }
        assignDefaultValues();

        setLoading(false);
    }

    const assignDefaultValues = () => {
        if (!state) {
            assignDefaultValuesAnyways();
        }
    }

    const assignDefaultValuesAnyways = () => {
        setState({
            
           
            
        });
    }

    const getCheckBoxONChange = (value, target) => {
        setState({
            ...state,
            [target] : value
        });
    }

    const saveTheForm = () => {
        setLoadingBtn(true);
        let objectToSave = {
            ...getGlobal().examination_location,
            'Thyroid' : {'isThyroid': isThyroid, ...state}
        }

        if (getGlobal().examination_location_id) {
            firestore.collection('Examination').doc(getGlobal().examination_location_id).update({
                examination_location: objectToSave,
            }).then(() => {
                notification.open({
                    message: 'Record Successfully Updated',
                    // icon: <DeleteOutlined style={{ color: '#f00' }} />,
                });
            }).catch(() => {
                notification.open({
                    message: 'An Error Occured',
                    // icon: <DeleteOutlined style={{ color: '#f00' }} />,
                });
            }).finally(() => {
                props.hasSaved();
                setLoadingBtn(false);
            });
        } else {
            firestore.collection('Examination').add({
                patient: firestore.collection("patients").doc(getGlobal().patientID),
                appointment: firestore.collection("appointments").doc(getGlobal().appointmentId),
                appointment_id: getGlobal().appointmentId,
                date: new Date(),
                examination_location: objectToSave,
            }).then(() => {
                notification.open({
                    message: 'Record Successfully Added',
                    // icon: <DeleteOutlined style={{ color: '#f00' }} />,
                });
            }).catch(() => {
                notification.open({
                    message: 'An Error Occured',
                    // icon: <DeleteOutlined style={{ color: '#f00' }} />,
                });
            }).finally(() => {
                props.hasSaved();
                setLoadingBtn(false);
            });
        }
  

        
    }

    const deleteThyroid = () => {


        firestore.collection('Examination').doc(getGlobal().examination_location_id).update({
            examination_location: {...getGlobal().examination_location, Thyroid: null}
            
        }).then(() => {
            notification.open({
                message: 'Record Successfully Delete',
                // icon: <DeleteOutlined style={{ color: '#f00' }} />,
            });
            setGlobal({examination_location: {...getGlobal().examination_location, Thyroid: null}})
            setPopup(!popup)
            props.hasSaved();
            assignDefaultValuesAnyways();
        }).catch(() => {
            notification.open({
                message: 'An Error Occured',
                // icon: <DeleteOutlined style={{ color: '#f00' }} />,
            });
        });


      
    }





    const ThyroidSelect = (event) => {
        setThyroid(event.target.value);
    }
    const NeckMassSelect = (event) => {
        setNeckMass(event.target.value);
        getSelectedFields(event);
    }
    const NeckNodesSelect = (event) => {
        setNeckNodes(event.target.value);
        getSelectedFields(event);
    }

    return (
        <div>

            <React.Fragment>
            {loading ? <Skeleton active /> : <>
               <Radio.Group name="Thyroid" value={isThyroid} onChange={ThyroidSelect} buttonStyle="solid" size="large" style={{marginTop: '20px'}}>
                <Radio.Button value={'Yes'}>Yes</Radio.Button>
                    

                    <Popover
                        content={<a onClick={deleteThyroid}>Delete</a>}
                        title="Are you sure you want to delete All Record of Thyroid?"
                        trigger="click"
                        visible={popup}
                        onVisibleChange={() => {
                            if(getGlobal().examination_location && getGlobal().examination_location.Thyroid){setPopup(!popup)}
                        }}
                    >
                        {/* <DeleteOutlined /> */}
                        <Radio.Button value={'No'}>No</Radio.Button>

                        
                    
                    </Popover>
               </Radio.Group>
               {isThyroid === 'Yes' && <Button className="SaveFormButton" loading={loadingBtn} style={{float: 'right'}} onClick={saveTheForm} type="primary">Save</Button>}
                    

                {isThyroid === 'Yes' ? 
                    
                    <ul className='showFieldsTable'>
                        <li><span>Face / Neck</span>
                            <Radio.Group name="Face / Neck" value={state && state['Face / Neck']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                <Radio.Button value={'Normal and Symmetrical'}>Normal and Symmetrical</Radio.Button>
                                <Radio.Button value={'Scar Mark'}>Scar Mark</Radio.Button>
                                <Radio.Button value={'Deformity'}>Deformity</Radio.Button>
                                <Radio.Button value={'Swelling'}>Swelling</Radio.Button>
                                <Radio.Button value={'Induration'}>Induration</Radio.Button>
                                <Radio.Button value={'Discharging Sinus/ Fistula'}>Discharging Sinus/ Fistula</Radio.Button>
                                <Radio.Button value={'other'}>Other</Radio.Button>
                            </Radio.Group>
                        </li>
                        <li><span>Lips &#38; Surrounding Skin</span>
                            <Radio.Group name="Lips & Surrounding Skin" value={state && state['Lips & Surrounding Skin']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                <Radio.Button value={'Normal'}>Normal</Radio.Button>
                                <Radio.Button value={'Fissuring'}>Fissuring</Radio.Button>
                                <Radio.Button value={'Ulceration'}>Ulceration</Radio.Button>
                                <Radio.Button value={'Growth'}>Growth</Radio.Button>
                                <Radio.Button value={'Other'}>Other</Radio.Button>
                            </Radio.Group>
                        </li>
                        <li><span>Stridor</span>
                            <Radio.Group name="Stridor" value={state && state['Stridor']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                <Radio.Button value={'No'}>No</Radio.Button>
                                <Radio.Button value={'Present'}>Present</Radio.Button>
                                <Radio.Button value={'Inspiratory'}>Inspiratory</Radio.Button>
                                <Radio.Button value={'Expiratory'}>Expiratory</Radio.Button>
                                <Radio.Button value={'Biphasic'}>Biphasic</Radio.Button>
                            </Radio.Group>
                        </li>
                        <li><span>Hoarseness</span>
                            <Radio.Group name="Hoarseness" value={state && state['Hoarseness']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                            <Radio.Button value={'No'}>No</Radio.Button>
                                <Radio.Button value={'Present'}>Present</Radio.Button>
                            </Radio.Group>
                        </li>
                        <li><span>Swallowing</span>
                            <Radio.Group name="Swallowing" value={state && state['Swallowing']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                <Radio.Button value={'Normal'}>Normal</Radio.Button>
                                <Radio.Button value={'Difficulty'}>Difficulty</Radio.Button>
                                <Radio.Button value={'Unable to swallow'}>Unable to swallow</Radio.Button>
                                <Radio.Button value={'Other'}>Other</Radio.Button>
                            </Radio.Group>
                        </li>
                        <li><span>Tongue Movements /Protrusion</span>
                            <Radio.Group name="Tongue Movements /Protrusion" value={state && state['Tongue Movements /Protrusion']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                <Radio.Button value={'Intact'}>Intact</Radio.Button>
                                <Radio.Button value={'Unable to Protrude'}>Unable to Protrude</Radio.Button>
                                <Radio.Button value={'Reduced on Rt Side'}>Reduced on Rt Side</Radio.Button>
                                <Radio.Button value={'Reduced on Lt Side'}>Reduced on Lt Side</Radio.Button>
                            </Radio.Group>
                        </li>
                        <li><span>Vasalva</span>
                            <Radio.Group name="Vasalva" value={state && state['Vasalva']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                <Radio.Button value={'Insignificant'}>Insignificant</Radio.Button>
                                <Radio.Button value={'Neck Swelling'}>Neck Swelling</Radio.Button>
                                <Radio.Button value={'Other'}>Other</Radio.Button>
                            </Radio.Group>
                        </li>
                        <li><span>Hands / Palms</span>
                            <Radio.Group name="Hands / Palms" value={state && state['Hands / Palms']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                <Radio.Button value={'Normal'}>Normal</Radio.Button>
                                <Radio.Button value={'Cold'}>Cold</Radio.Button>
                                <Radio.Button value={'Warm'}>Warm</Radio.Button>
                                <Radio.Button value={'Sweating'}>Sweating</Radio.Button>
                            </Radio.Group>
                        </li>
                        <li><span>Pulse</span>
                            <Radio.Group name="Pulse" value={state && state['Pulse']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                <Radio.Button value={'Normal'}>Normal</Radio.Button>
                                <Radio.Button value={'Tachycardia'}>Tachycardia</Radio.Button>
                                <Radio.Button value={'Bradycardia'}>Bradycardia</Radio.Button>
                                <Radio.Button value={'Arrhythmia'}>Arrhythmia</Radio.Button>
                            </Radio.Group>
                        </li>
                        <li><span>Tremors</span>
                            <Radio.Group name="Tremors" value={state && state['Tremors']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                <Radio.Button value={'No'}>No</Radio.Button>
                                <Radio.Button value={'Yes'}>Yes</Radio.Button>
                                <Radio.Button value={'Other'}>Other</Radio.Button>
                            </Radio.Group>
                        </li>
                        <li><span>Peberton’s Sign</span>
                            <Radio.Group name="Peberton’s Sign" value={state && state['Peberton’s Sign']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                <Radio.Button value={'Negative'}>Negative</Radio.Button>
                                <Radio.Button value={'Positive'}>Positive</Radio.Button>
                            </Radio.Group>
                        </li>
                        <li><span>Lids</span>
                            <Radio.Group name="Lids" value={state && state['Lids']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                <Radio.Button value={'Normal'}>Normal</Radio.Button>
                                <Radio.Button value={'Lid Lag'}>Lid Lag</Radio.Button>
                                <Radio.Button value={'Lid Retraction'}>Lid Retraction</Radio.Button>
                                <Radio.Button value={'Proptosis'}>Proptosis</Radio.Button>
                            </Radio.Group>
                        </li>
                        <li><span>Ocular Movements</span>
                            <Radio.Group name="Ocular Movements" value={state && state['Ocular Movements']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                <Radio.Button value={'Normal'}>Normal</Radio.Button>
                                <Radio.Button value={'Restricted'}>Restricted</Radio.Button>
                                <Radio.Button value={'Other'}>Other</Radio.Button>
                            </Radio.Group>
                        </li>

                        <li><span>Neck Mass</span>
                            <Radio.Group name="NeckMass" value={state && state.NeckMass} onChange={NeckMassSelect} buttonStyle="solid" size="large" style={{marginTop: '20px'}}>
                                <Radio.Button value={'No'}>No</Radio.Button>
                                <Radio.Button value={'Yes'}>Yes</Radio.Button>
                            </Radio.Group>

                        {isNeckMass === 'Yes' ?
                          <ul className='nestedUl'>
                            <li><span>Moves with Swallowing</span>
                                <Radio.Group name="Moves with Swallowing" value={state && state['Moves with Swallowing']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                    <Radio.Button value={'Yes'}>Yes</Radio.Button>
                                    <Radio.Button value={'No'}>No</Radio.Button>
                                </Radio.Group>
                            </li>
                            <li><span>Moves with Tongue Protrusion</span>
                                <Radio.Group name="Moves with Tongue Protrusion" value={state && state['Moves with Tongue Protrusion']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                    <Radio.Button value={'Yes'}>Yes</Radio.Button>
                                    <Radio.Button value={'No'}>No</Radio.Button>
                                </Radio.Group>
                            </li>
                            <li><span>Type</span>
                                <Radio.Group name="Type" value={state && state['Type']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                    <Radio.Button value={'Globular'}>Globular</Radio.Button>
                                    <Radio.Button value={'Multinodular'}>Multinodular</Radio.Button>
                                    <Radio.Button value={'Irregular'}>Irregular</Radio.Button>
                                    <Radio.Button value={'Other'}>Other</Radio.Button>
                                </Radio.Group>
                            </li>
                            <li><span>Numbers</span>
                                <Radio.Group name="Numbers" value={state && state['Numbers']} onChange={getSelectedFields}  buttonStyle="solid" size="large">
                                    <Radio.Button value={'Solitary'}>Solitary</Radio.Button>
                                    <Radio.Button value={'Multiple'}>Multiple</Radio.Button>
                                    <Radio.Button value={'Other'}>Other</Radio.Button>
                                </Radio.Group>
                            </li>
                            <li><span>Location</span>
                                <Radio.Group name="Location" value={state && state['Location']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                    <Radio.Button value={'Mid of Neck'}>Mid of Neck</Radio.Button>
                                    <Radio.Button value={'Towards Right side'}>Towards Right side</Radio.Button>
                                    <Radio.Button value={'Towards Left'}>Towards Left</Radio.Button>
                                    <Radio.Button value={'Posterior Triangle'}>Posterior Triangle</Radio.Button>
                                    <Radio.Button value={'Other'}>Other</Radio.Button>
                                </Radio.Group>
                            </li>
                            <li><span>Overlying Skin</span>
                                <Radio.Group name="Overlying Skin" value={state && state['Overlying Skin']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                    <Radio.Button value={'Normal'}>Normal</Radio.Button>
                                    <Radio.Button value={'Indurated'}>Indurated</Radio.Button>
                                    <Radio.Button value={'Indurated'}>Ulcerated</Radio.Button>
                                    <Radio.Button value={'Indurated'}>Fistula/Sinus</Radio.Button>
                                    <Radio.Button value={'Other'}>Other</Radio.Button>
                                </Radio.Group>
                            </li>
                            <li><span>Temperature</span>
                                <Radio.Group name="Temperature" value={state && state['Temperature']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                    <Radio.Button value={'Normal'}>Normal</Radio.Button>
                                    <Radio.Button value={'Raised'}>Raised</Radio.Button>
                                    <Radio.Button value={'Decreased'}>Decreased</Radio.Button>
                                </Radio.Group>
                            </li>
                            <li><span>Tenderness</span>
                                <Radio.Group name="Tenderness" value={state && state['Tenderness']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                    <Radio.Button value={'Non-tender'}>Non-tender</Radio.Button>
                                    <Radio.Button value={'Tender'}>Tender</Radio.Button>
                                </Radio.Group>
                            </li>
                            <li><span>Surface</span>
                                <Radio.Group name="Surface" value={state && state['Surface']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                    <Radio.Button value={'Smooth'}>Smooth</Radio.Button>
                                    <Radio.Button value={'Irregular'}>Irregular</Radio.Button>
                                    <Radio.Button value={'Other'}>Nodular</Radio.Button>
                                    <Radio.Button value={'Irregular'}>Lobulated</Radio.Button>
                                </Radio.Group>
                            </li>
                            <li><span>Margins/Edges</span>
                                <Radio.Group name="Margins/Edges" value={state && state['Margins/Edges']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                    <Radio.Button value={'Poorly Defined'}>Poorly Defined</Radio.Button>
                                    <Radio.Button value={'Well Defined'}>Well Defined</Radio.Button>
                                </Radio.Group>
                            </li>
                            <li><span>Shape</span>
                                <Radio.Group name="Shape" value={state && state['Shape']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                    <Radio.Button value={'Spherical'}>Spherical</Radio.Button>
                                    <Radio.Button value={'Ovoid'}>Ovoid</Radio.Button>
                                    <Radio.Button value={'Hard'}>Irregular</Radio.Button>
                                </Radio.Group>
                            </li>
                            <li><span>Consistency</span>
                                <Radio.Group name="Consistency" value={state && state['Consistency']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                    <Radio.Button value={'Firm'}>Firm</Radio.Button>
                                    <Radio.Button value={'Soft'}>Soft</Radio.Button>
                                    <Radio.Button value={'Hard'}>Hard</Radio.Button>
                                    <Radio.Button value={'Firm to Hard'}>Firm to Hard</Radio.Button>
                                </Radio.Group>
                            </li>
                            <li><span>Overlying Skin</span>
                                <Radio.Group name="Overlying Skin" value={state && state['Overlying Skin']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                    <Radio.Button value={'Not Fixed'}>Not Fixed</Radio.Button>
                                    <Radio.Button value={'Fixed'}>Fixed</Radio.Button>
                                </Radio.Group>
                            </li> 
                            <li><span>Margins</span>
                                <Radio.Group name="Margins" value={state && state['Margins']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                    <Radio.Button value={'Regular'}>Regular</Radio.Button>
                                    <Radio.Button value={'Irregular'}>Irregular</Radio.Button>
                                    <Radio.Button value={'Other'}>Other</Radio.Button>
                                </Radio.Group>
                            </li>
                            <li><span>Swelling</span>
                                <Radio.Group name="Swelling" value={state && state['Swelling']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                    <Radio.Button value={'Mobile'}>Mobile</Radio.Button>
                                    <Radio.Button value={'Fixed to underlying Structure'}>Fixed to underlying Structure</Radio.Button>
                                    <Radio.Button value={'Other'}>Other</Radio.Button>
                                </Radio.Group>
                            </li>
                            <li><span>Contraction of Muscles</span>
                                <Radio.Group name="Contraction of Muscles" value={state && state['Contraction of Muscles']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                    <Radio.Button value={'Doesn’t Change Size '}>Doesn’t Change Size </Radio.Button>
                                    <Radio.Button value={'Size Increased'}>Size Increased</Radio.Button>
                                    <Radio.Button value={'Sized Decreased'}>Sized Decreased</Radio.Button>
                                </Radio.Group>
                            </li>
                            <li><span>Pulsatile</span>
                                <Radio.Group name="Pulsatile" value={state && state['Pulsatile']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                    <Radio.Button value={'No'}>No</Radio.Button>
                                    <Radio.Button value={'Yes'}>Yes</Radio.Button>
                                </Radio.Group>
                            </li>
                            <li><span>Fluctuant</span>
                                <Radio.Group name="Fluctuant" value={state && state['Fluctuant']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                <Radio.Button value={'No'}>No</Radio.Button>
                                    <Radio.Button value={'Yes'}>Yes</Radio.Button>
                                </Radio.Group>
                            </li>
                            <li><span>Reducible</span>
                                <Radio.Group name="Reducible" value={state && state['Reducible']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                    <Radio.Button value={'No'}>No</Radio.Button>
                                    <Radio.Button value={'Yes'}>Yes</Radio.Button>
                                </Radio.Group>
                            </li>
                            <li><span>Compressible</span>
                                <Radio.Group name="Compressible" value={state && state['Compressible']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                    <Radio.Button value={'No'}>No</Radio.Button>
                                    <Radio.Button value={'Yes'}>Yes</Radio.Button>
                                </Radio.Group>
                            </li>
                            <li><span>Size</span>
                                <Radio.Group name="Size" value={state && state['Size']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                    <Radio.Button value={'&#60; 2cm'}>&#60; 2cm</Radio.Button>
                                    <Radio.Button value={'2-4cm'}>2-4cm</Radio.Button>
                                    <Radio.Button value={'&#62; 4cm'}>&#62; 4cm</Radio.Button>
                                    <Radio.Button value={'Other'}>Other</Radio.Button>
                                </Radio.Group>
                            </li>
                            <li><span>Trans-illumination</span>
                                <Radio.Group name="Trans-illumination" value={state && state['Trans-illumination']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                    <Radio.Button value={'No'}>No</Radio.Button>
                                    <Radio.Button value={'Yes'}>Yes</Radio.Button>
                                </Radio.Group>
                            </li>
                            <li><span>Bruit</span>
                                <Radio.Group name="Bruit" value={state && state['Bruit']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                    <Radio.Button value={'No'}>No</Radio.Button>
                                    <Radio.Button value={'Yes'}>Yes</Radio.Button>
                                </Radio.Group>
                            </li> 
                           </ul>
                        
                        : ''
                        }

                        </li>
  
                        <li><span>Tracheal Position</span>
                            <Radio.Group name="Tracheal Position" value={state && state['Tracheal Position']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                <Radio.Button value={'Central'}>Central</Radio.Button>
                                <Radio.Button value={'Rt sided Deviation'}>Rt sided Deviation</Radio.Button>
                                <Radio.Button value={'Lt Sided Deviation'}>Lt Sided Deviation</Radio.Button>
                                <Radio.Button value={'Other'}>Other</Radio.Button>
                            </Radio.Group>
                        </li>

                       <li><span>Laryngeal Crepitus</span>
                            <Radio.Group name="Laryngeal Crepitus" value={state && state['Laryngeal Crepitus']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                <Radio.Button value={'Present'}>Present</Radio.Button>
                                <Radio.Button value={'Absent'}>Absent</Radio.Button>
                                <Radio.Button value={'Other'}>Other</Radio.Button>
                            </Radio.Group>
                        </li>
                        <li><span>Sensations of Submental area</span>
                            <Radio.Group name="Sensations of Submental area" value={state && state['Sensations of Submental area']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                <Radio.Button value={'Intact'}>Intact</Radio.Button>
                                <Radio.Button value={'Rt Reduced/Absent'}>Rt Reduced/Absent</Radio.Button>
                                <Radio.Button value={'Lt Reduced/Absent'}>Lt Reduced/Absent</Radio.Button>
                                <Radio.Button value={'Bilateral Reduced/Absent'}>Bilateral Reduced/Absent</Radio.Button>
                            </Radio.Group>
                        </li>
                        <li><span>Trismus</span>
                            <Radio.Group name="Trismus" value={state && state['Trismus']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                <Radio.Button value={'Not Present'}>Not Present</Radio.Button>
                                <Radio.Button value={'Grade I'}>Grade I</Radio.Button>
                                <Radio.Button value={'Grade II'}>Grade II</Radio.Button>
                                <Radio.Button value={'Grade III'}>Grade III</Radio.Button>
                            </Radio.Group>
                        </li>
                        <li><span>Dental Health</span>
                            <Radio.Group name="Dental Health" value={state && state['Dental Health']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                <Radio.Button value={'Dentulous'}>Dentulous</Radio.Button>
                                <Radio.Button value={'Edentulous'}>Edentulous</Radio.Button>
                                <Radio.Button value={'Partially Edentulous'}>Partially Edentulous</Radio.Button>
                            </Radio.Group>
                        </li>
                        <li><span>Oro-Dental Hygiene</span>
                            <Radio.Group name="Oro-Dental Hygiene" value={state && state['Oro-Dental Hygiene']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                <Radio.Button value={'Satisfactory'}>Satisfactory</Radio.Button>
                                <Radio.Button value={'Unsatisfactory'}>Unsatisfactory</Radio.Button>
                                <Radio.Button value={'Staining on Teeth'}>Staining on Teeth</Radio.Button>
                            </Radio.Group>
                        </li>
                        <li><span>Palatal Movements</span>
                            <Radio.Group name="Palatal Movements" value={state && state['Palatal Movements']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                <Radio.Button value={'Intact'}>Intact</Radio.Button>
                                <Radio.Button value={'Reduced on Rt Side'}>Reduced on Rt Side</Radio.Button>
                                <Radio.Button value={'Reduced on Lt Side'}>Reduced on Lt Side</Radio.Button>
                                <Radio.Button value={'Other'}>Other</Radio.Button>
                            </Radio.Group>
                        </li>
                        <li><span>Oral Cavity/Oropharynx</span>
                            <Radio.Group name="Tonsils" value={state && state['Tonsils']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                <Radio.Button value={'Normal'}>Normal</Radio.Button>
                                <Radio.Button value={'Inflamed'}>Inflamed</Radio.Button>
                                <Radio.Button value={'Congested'}>Congested</Radio.Button>
                                <Radio.Button value={'Pus Follicles'}>Pus Follicles</Radio.Button>
                                <Radio.Button value={'Other'}>Other</Radio.Button>
                            </Radio.Group>
                            <Radio.Group name="hypertrophy" value={state && state['hypertrophy']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                <Radio.Button value={'Grade I hypertrophy'}>Grade I hypertrophy</Radio.Button>
                                <Radio.Button value={'Grade II hypertrophy'}>Grade II hypertrophy</Radio.Button>
                                <Radio.Button value={'Grade III hypertrophy'}>Grade III hypertrophy</Radio.Button>
                                <Radio.Button value={'Grade IV Hypertrophy'}>Grade IV Hypertrophy</Radio.Button>
                            </Radio.Group>
                        </li>
                        <li><span>Taster Sensations</span>
                            <Radio.Group name="Taster Sensations" value={state && state['Taster Sensations']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                <Radio.Button value={'Intact'}>Intact</Radio.Button>
                                <Radio.Button value={'Reduced'}>Reduced</Radio.Button>
                                <Radio.Button value={'Absent'}>Absent</Radio.Button>
                                <Radio.Button value={'Altered'}>Altered</Radio.Button>
                            </Radio.Group>
                        </li>
                        <li><span>Video Laryngoscopy</span>
                            <Radio.Group name="Video Laryngoscopy"  buttonStyle="solid" size="large">
                                <Radio.Button value={'Normal '}>Normal </Radio.Button>
                                <Radio.Button value={'Congested / Edematous Larynx'}>Congested / Edematous Larynx</Radio.Button>
                                <Radio.Button value={'Thickened VC'}>Thickened VC</Radio.Button>
                                <Radio.Button value={'Phonatory Gap'}>Phonatory Gap</Radio.Button>
                                <Radio.Button value={'VC Nodule/s'}>VC Nodule/s</Radio.Button>
                            </Radio.Group>
                        </li>
                        <li><span>Dont Know</span>
                            {/* <Radio.Group name="Dont Know"  buttonStyle="solid" size="large">
                                <Radio.Button value={'VC Poly '}>VC Poly </Radio.Button>
                                <Radio.Button value={'VC Growth'}>VC Growth</Radio.Button>
                                <Radio.Button value={'Other'}>Other</Radio.Button>
                            </Radio.Group>
                            <Radio.Group name="Dont Know2"  buttonStyle="solid" size="large">
                                <Radio.Button value={'Rt VC Immobile '}>Rt VC Immobile </Radio.Button>
                                <Radio.Button value={'Left VC Immobile'}>Left VC Immobile</Radio.Button>
                                <Radio.Button value={'Other'}>Both VC Immobile</Radio.Button>
                            </Radio.Group>
                        </li>
                        <li><span>Posterior Rhinoscopy</span>
                            <Radio.Group name="Posterior Rhinoscopy"  buttonStyle="solid" size="large">
                                <Radio.Button value={'Insignificant'}>Insignificant</Radio.Button>
                                <Radio.Button value={'Polypoidal Mass'}>Polypoidal Mass</Radio.Button>
                                <Radio.Button value={'Adenoids Hyperplasia'}>Adenoids Hyperplasia</Radio.Button>
                                <Radio.Button value={'Growth'}>Growth</Radio.Button>
                                <Radio.Button value={'Other'}>Other</Radio.Button>
                            </Radio.Group> */}
                                <Checkbox.Group name="Video Laryngoscopy" value={state && state['Video Laryngoscopy']} buttonStyle="solid" onChange={(val) => getCheckBoxONChange(val, 'Video Laryngoscopy')} size="large">
                                    <Checkbox value="Normal" style={{ lineHeight: '32px' }}>
                                        Normal
                                    </Checkbox>
                                    <Checkbox value="Congested / Edematous Larynx" style={{ lineHeight: '32px' }}>
                                        Congested / Edematous Larynx
                                    </Checkbox>
                                    <Checkbox value="Thickened VC" style={{ lineHeight: '32px' }}>
                                        Thickened VC
                                    </Checkbox>
                                    <Checkbox value="Phonatory Gap" style={{ lineHeight: '32px' }}>
                                        Phonatory Gap
                                    </Checkbox>
                                    <Checkbox value="VC Nodule/s" style={{ lineHeight: '32px' }}>
                                        VC Nodule/s
                                    </Checkbox>
                                    <Checkbox value="VC Poly" style={{ lineHeight: '32px' }}>
                                        VC Poly
                                    </Checkbox>
                                    <Checkbox value="VC Growth" style={{ lineHeight: '32px' }}>
                                        VC Growth
                                    </Checkbox>
                                    <Checkbox value="Other" style={{ lineHeight: '32px' }}>
                                        Other
                                    </Checkbox>
                                    <Checkbox value="Rt VC Immobile" style={{ lineHeight: '32px' }}>
                                        Rt VC Immobile
                                    </Checkbox>
                                    <Checkbox value="Left VC Immobile" style={{ lineHeight: '32px' }}>
                                        Left VC Immobile
                                    </Checkbox>
                                    <Checkbox value="Both VC Immobile" style={{ lineHeight: '32px' }}>
                                        Both VC Immobile
                                    </Checkbox>
                                </Checkbox.Group>

                        </li>

                        <li><span>Neck Nodes</span>
                            <Radio.Group name="isPalpable" value={state && state.isPalpable} onChange={NeckNodesSelect} buttonStyle="solid" size="large" style={{marginTop: '20px'}}>
                                <Radio.Button value={'Not Palpable'}>Not Palpable</Radio.Button>
                                <Radio.Button value={'Palpable'}>Palpable</Radio.Button>
                            </Radio.Group>

                        {isNeckNodes === 'Palpable' ?
                          <ul className='nestedUl'>
                            <li>
                                <Radio.Group name="Palpable1" value={state && state['Palpable1']} onChange={getSelectedFields}  buttonStyle="solid" size="large">
                                    <Radio.Button value={'Level 1'}>Level 1</Radio.Button>
                                    <Radio.Button value={'Level 2'}>Level 2</Radio.Button>
                                    <Radio.Button value={'Level 3'}>Level 3</Radio.Button>
                                    <Radio.Button value={'Level 4'}>Level 4</Radio.Button>
                                    <Radio.Button value={'Level 5'}>Level 5</Radio.Button>
                                    <Radio.Button value={'Level 6'}>Level 6</Radio.Button>
                                    <Radio.Button value={'Level 7'}>Level 7</Radio.Button>
                                </Radio.Group>
                            </li>
                            <li>
                                <Radio.Group name="Palpable2" value={state && state['Palpable2']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                    <Radio.Button value={'Single'}>Single</Radio.Button>
                                    <Radio.Button value={'Multiple'}>Multiple</Radio.Button>
                                </Radio.Group>
                            </li>
                            <li>
                                <Radio.Group name="Palpable3" value={state && state['Palpable3']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                    <Radio.Button value={'Ipsilateral'}>Ipsilateral</Radio.Button>
                                    <Radio.Button value={'Bilateral'}>Bilateral</Radio.Button>
                                    <Radio.Button value={'Contralateral'}>Contralateral</Radio.Button>
                                </Radio.Group>
                            </li>
                            <li>
                                <Radio.Group name="Palpable4" value={state && state['Palpable4']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                    <Radio.Button value={'&#60; 3 cm'}>&#60; 3 cm</Radio.Button>
                                    <Radio.Button value={'3 - 6 cm'}>3 - 6 cm</Radio.Button>
                                    <Radio.Button value={'&#62; 6 cm'}>&#62; 6 cm</Radio.Button>
                                </Radio.Group>
                            </li>
                            <li>
                                <Radio.Group name="Palpable5" value={state && state['Palpable5']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                    <Radio.Button value={'Tender'}>Tender</Radio.Button>
                                    <Radio.Button value={'Non-tender'}>Non-tender</Radio.Button>
                                </Radio.Group>
                            </li>
                            <li>
                                <Radio.Group name="Palpable6" value={state && state['Palpable6']} onChange={getSelectedFields} buttonStyle="solid" size="large">
                                    <Radio.Button value={'Mobile'}>Mobile</Radio.Button>
                                    <Radio.Button value={'Fixed'}>Fixed</Radio.Button>
                                </Radio.Group>
                            </li>
                          
                           </ul>
                        
                      
                        : ''
                        }

                        </li>
 
                        <Button className="SaveFormButton" loading={loadingBtn} onClick={saveTheForm} type="primary">Save</Button>
                        
                        
                    </ul>

                : ''

                }
                </>}
            </React.Fragment>

            
        </div>
    );
}

export default Thyroid;
